import BlogRootHero from "./BlogRootHero";

export default BlogRootHero;
